<div class="tracking-details px-8" *ngIf="transportJourneys; let t">

  <div *ngIf="!isManualIntermodalLinkage; else intermodalBoxView">
    <div class="row line pb-18">
      <!-- Left side -->
      <div class="col">
  
        <p *ngIf="t.shipToPort?.origin">
          <td class="label">{{ 'common.origin_txt' | translate }} </td>
          <td class="value text-bold">
            {{t.shipToPort?.origin || ''}}
          </td>
        </p>
  
        <!-- Origin ATD/ETD -->
        <p *ngIf="t.shipToPort?.atd && !authService.isEximUser">
          <td class="label">{{ 'common.origin_txt' | translate }} ATD </td>
          <td class="value text-bold">{{ t.shipToPort.atd }}</td>
        </p>
        <p *ngIf="!t.shipToPort?.atd && t.shipToPort?.etd && !authService.isEximUser">
          <td class="label">{{ 'common.origin_txt' | translate }} ETD </td>
          <td class="value text-bold">{{ t.shipToPort.etd}}</td>
        </p>
      </div>
  
      <!-- Right side -->
      <div class="col right mr-12">
        <p *ngIf="t.shipToDestination?.destination">
          <span class="label">{{ 'common.destination_txt' | translate }}</span>
          <span class="value">{{t.shipToDestination?.destination || ''}}</span>
        </p>
  
        <p *ngIf="t.shipToDestination?.ata && !authService.isEximUser">
          <span class="label">{{ 'common.destination_txt' | translate }} ATA</span>
          <span class="value">{{ t.shipToDestination.ata }}</span>
        </p>
        <p *ngIf="!t.shipToDestination?.ata && t.shipToDestination?.eta && !authService.isEximUser">
          <span class="label">{{ 'common.destination_txt' | translate }} ETA</span>
          <span class="value">{{ t.shipToDestination?.eta || '' }}</span>
        </p>
  
      </div>
    </div>
  
  
    <div class="row py-8">
      <div class="col">
        <p>
          <td class="label">{{ 'common.shipper_txt' | translate }}</td>
          <td class="value">
            <span>
              {{shipment?.consignor || ''}}
            </span>
          </td>
        </p>
        <p>
          <td class="label">{{ 'shipments.ocean_shipments.origin_ocean_port_txt' | translate }}</td>
          <td class="value">
            <span *ngIf="t.portToPort?.originPort">
              {{t.portToPort.originPort || ''}}
            </span>
          </td>
        </p>
  
        <p *ngIf="!authService.isEximUser">
          <td class="label">{{ 'shipments.ocean_shipments.ocean_port_gate_in_txt' | translate }}</td>
          <td class="value">
            <span *ngIf="t.portToPort.portGateInTime">
              {{t.portToPort.portGateInTime}}
            </span>
          </td>
        </p>
  
  
        <!-- Port ATD/ETD -->
        <p *ngIf="t.portToPort.portAtd && !authService.isEximUser">
          <td class="label">{{ 'shipments.ocean_shipments.ocean_port_txt' | translate }} ATD </td>
          <td class="value">{{t.portToPort.portAtd }}</td>
        </p>
        <p *ngIf="!t.portToPort.portAtd && !authService.isEximUser">
          <td class="label">{{ 'shipments.ocean_shipments.ocean_port_txt' | translate }} ETD </td>
          <td class="value">{{ t.portToPort.portEtd || '' }}</td>
        </p>

        <!-- Destination Terminal ETA -->
        <p *ngIf="t?.portToPort?.destinationTerminalEta && !authService.isEximUser">
          <td class="label">{{ 'shipments.ocean_shipments.destination_terminal_eta_txt' | translate }} </td>
          <td class="value">
            {{t.portToPort.destinationTerminalEta }}
            <img src="assets/images/logos/dpWorldLogo-ball.svg" width="16" height="16" class="ml-1" style="margin-top: 2px;" tooltip="DP World port data available" [showDelay]="300" />
          </td>
        </p>
  
      </div>
  
      <!-- Right side -->
      <div class="col right justify-centent-end">
        <p>
          <td class="label text-right">{{ 'common.consignee_txt' | translate }}</td>
          <td class="value">
            <span>
              {{shipment?.consignee || ''}}
            </span>
          </td>
        </p>
        <p>
          <span class="label text-right">{{ 'common.destination_txt' | translate }} {{ 'shipments.ocean_shipments.ocean_port_txt' | translate }}</span>
          <span class="value">{{t.portToPort.destinationPort || ''}} </span>
        </p>
        <p *ngIf="t.portToPort.portAta && !authService.isEximUser">
          <span class="label text-right"> {{ 'shipments.ocean_shipments.ocean_port_txt' | translate }} ATA </span>
          <span class="value"> {{ t.portToPort.portAta }} </span>
        </p>
        <p *ngIf="!t.portToPort.portAta && !t.portToPort.predictedHubEta && !authService.isEximUser">
          <span class="label text-right"> {{ 'shipments.ocean_shipments.carrier_eta_txt' | translate }} </span>
          <span class="value"> {{ t.portToPort.hubEta || '' }} </span>
        </p>
  
        <p *ngIf="t.portToPort.predictedHubEta && !t.portToPort.portAta && !authService.isEximUser">
          <span class="label text-right predicted-eta" placement="bottom" 
                [tooltip]="getPredictiveTootltip(t)">
            <img width="14" [src]="SvgMap.flowNewSquare" alt="">
            {{ 'common.flow_predicts_txt' | translate }}
          </span>
          <span class="value d-inline-flex justify-content-end">
              <span>{{ t.portToPort.predictedHubEta}}</span>
              <span *ngIf="t.portToPort.hubEtaDaysDifference" class='highlight'> {{getPredictiveDaysDifference(t.portToPort.hubEtaDaysDifference)}}</span>
          </span>
        </p>
  
        <p *ngIf="t.portToPort.portGateOutTime && !authService.isEximUser">
          <span class="label text-right"> {{ 'shipments.ocean_shipments.ocean_port_gate_out_txt' | translate }} </span>
          <span class="value">{{t.portToPort.portGateOutTime}}</span>
        </p>
  
      </div>
    </div>
  </div>
  <ng-template #intermodalBoxView>
    <div class="box hScroller" >
      <div fxLayout="row" fxLayoutGap="16px">
        <div>
          <lable class="label label-box">{{ 'common.shipper_txt' | translate }}</lable>
          <div class="mt-4 text-bold value value-box"> {{ shipment?.consignor || '-' }}</div>
        </div>
        <div *ngIf="!authService.isEximUser">
          <lable class="label label-box">{{ 'common.origin_address_txt' | translate }}</lable>
          <div class="mt-4 text-bold value value-box"> {{ t.shipToPort?.originFullAddress || '-' }}</div>
        </div>
        <div *ngIf="!authService.isEximUser">
          <lable class="label label-box">ETD</lable>
          <div class="mt-4 text-bold value value-box"> {{ t.shipToPort?.etd || '-' }}</div>
        </div>
        <div *ngIf="!authService.isEximUser">
          <lable class="label label-box">ATD</lable>
          <div class="mt-4 text-bold value value-box"> {{ t.shipToPort?.atd || '-' }}</div>
        </div>
        <div *ngIf="!authService.isEximUser">
          <lable class="label label-box">{{ 'common.mode_txt' | translate }}</lable>
          <div class="mt-4 text-bold value value-box">{{ 'common.road_txt' | translate }}</div>
        </div>
      </div>
      <hr class="separator">
      <div fxLayout="row" fxLayoutGap="16px">
        <div>
          <lable class="label label-box"></lable>
          <div class="mt-4 text-bold value value-box"></div>
        </div>
        <div>
          <lable class="label label-box">{{ 'shipments.ocean_shipments.origin_ocean_port_txt' | translate }}</lable>
          <div class="mt-4 text-bold value value-box"> {{ t.portToPort?.originPort || '-' }}</div>
        </div>
        <div *ngIf="!authService.isEximUser">
          <lable class="label label-box">{{ 'shipments.ocean_shipments.ocean_port_gate_in_txt' | translate }}</lable>
          <div class="mt-4 text-bold value value-box"> {{ t.portToPort?.portGateInTime || '-' }}</div>
        </div>
        <div *ngIf="!authService.isEximUser">
          <lable class="label label-box">{{ 'shipments.ocean_shipments.ocean_port_txt' | translate }} ATD</lable>
          <div class="mt-4 text-bold value value-box"> {{ t.portToPort?.portAtd || '-' }}</div>
        </div>
      </div>
    </div>
    <div class="box hScroller">
      <div fxLayout="row" fxLayoutGap="16px">
        <div>
          <lable class="label label-box">{{ 'common.consignee_txt' | translate }}</lable>
          <div class="mt-4 text-bold value value-box">{{ shipment?.consignee || '-' }}</div>
        </div>
        <div *ngIf="!authService.isEximUser">
          <lable class="label label-box">{{ 'common.destination_address_txt' | translate }}</lable>
          <div class="mt-4 text-bold value value-box"> {{ t.shipToDestination?.destinationFullAddress || '-' }}</div>
        </div>
        <div *ngIf="!authService.isEximUser">
          <lable class="label label-box">ETA</lable>
          <div class="mt-4 text-bold value value-box"> {{ t.shipToDestination?.eta || '-' }}</div>
        </div>
        <div *ngIf="!authService.isEximUser">
          <lable class="label label-box">ATA</lable>
          <div class="mt-4 text-bold value value-box"> {{ t.shipToDestination?.ata || '-' }}</div>
        </div>
        <div *ngIf="!authService.isEximUser">
          <lable class="label label-box">{{ 'common.mode_txt' | translate }}</lable>
          <div class="mt-4 text-bold value value-box">{{ 'common.road_txt' | translate }}</div>
        </div>
      </div>
      <hr class="separator">
      <div fxLayout="row" fxLayoutGap="16px">
        <div>
          <lable class="label label-box"></lable>
          <div class="mt-4 text-bold value value-box"></div>
        </div>
        <div>
          <lable class="label label-box">{{ 'shipments.ocean_shipments.destination_ocean_port_txt' | translate }}</lable>
          <div class="mt-4 text-bold value value-box"> {{ t.portToPort?.destinationPort || '-' }}</div>
        </div>
        <div *ngIf="!authService.isEximUser">
          <lable class="label label-box">{{ 'common.port_txt' | translate }} ETA</lable>
          <div class="mt-4 text-bold value value-box"> {{ t.portToPort?.hubEta || '-' }}</div>
        </div>
        <div *ngIf="t.portToPort.predictedHubEta && !authService.isEximUser">
          <label class="label label-box text-right predicted-eta" placement="bottom" 
                [tooltip]="getPredictiveTootltip(t)">
            <img width="14" [src]="SvgMap.flowNewSquare" alt="">
            {{ 'common.flow_predicts_txt' | translate }}
          </label>
          <div *ngIf="isUserLoggedIn && t.portToPort.predictedHubEta && !t.portToPort.portAta">
            <div class="value value-box justify-content-end mt-4" *ngIf='isPredictiveEtaEnabled'>
                <span>{{ t.portToPort.predictedHubEta}}</span>
                <span *ngIf="t.portToPort.hubEtaDaysDifference" class='highlight'>
                  {{getPredictiveDaysDifference(t.portToPort.hubEtaDaysDifference)}}
                </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>